// Module
var code = "<a ng-href=\"{{ url }}\" class=\"linked clickable hover\"> <div class=\"top\">GOLD COAST LI FEATURED PROPERTIES</div> <div class=\"front-banner rounded rounded-t\"> <img ng-src=\"{{ src }}\"/> </div> <div class=\"bottom rounded br--bottom\" ng-bind=\"hline\"></div> </a> ";
// Exports
var _module_exports =code;;
var path = '/codebuild/output/src2571761514/src/frontend/js/directives/public/featuredCommercial.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;